import React, { useState, useEffect } from 'react';
import { cn } from '@chapche/ui';

const SelectWithTokensInput = ({ selectWithTokensManager }) => {
    const [searchValue, setSearchValue] = useState('');

    const changeItemsList = () => {
        setSearchValue(selectWithTokensManager.getSearchString());
    };

    useEffect(() => {
        selectWithTokensManager.registerItemsChangingObserver(changeItemsList);
        return () => selectWithTokensManager.registerItemsChangingObserver(changeItemsList);
    }, [selectWithTokensManager]);

    const setSearchInputValue = (e) => {
        selectWithTokensManager.setSearchFilterValue(e.target.value);
        if (selectWithTokensManager.isSearchStringChanged()) {
            setSearchValue(selectWithTokensManager.getSearchString());
        }
    };

    const handleSearchInputValue = (e) => {
        if (e.key === 'Enter') {
            selectWithTokensManager.handleSearchFilterValue();
            setSearchValue('');
        }
    };

    return (
        <input
            className={cn(
                'block__content select__block-input min-w-[80px] flex-1 border-0 bg-transparent px-8 py-4 font-montserrat-medium text-l text-ink outline-none',
                'placeholder:text-secondary-light-grey',
            )}
            value={searchValue}
            onChange={setSearchInputValue}
            onKeyDown={handleSearchInputValue}
            placeholder={selectWithTokensManager.getCurrentItems().length === 0 ? selectWithTokensManager.getPlaceHolder() : ''}
        />
    );
};

export default SelectWithTokensInput;
